import React, {useState, useEffect, useRef} from 'react';
import './CitySelector.scss';

const CloseButton = ({onClick}) => (
  <span className='close-button' onClick={onClick}>
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M13.734 2.275a.906.906 0 0 0-1.284 0L8 6.717l-4.45-4.45a.906.906 0 1 0-1.284 1.282L6.716 8l-4.45 4.45a.906.906 0 1 0 1.283 1.284L8 9.284l4.45 4.45a.906.906 0 1 0 1.284-1.284L9.284 8l4.45-4.45a.912.912 0 0 0 0-1.275z'
        fill='var(--theme-primary, #810ea9)'
      />
    </svg>
  </span>
);

const CitySelector = ({cities,pickupDate, onSelect}) => {
  const [filterText, setFilterText] = useState('');
  const [selectedCity, setSelectedCity] = useState(null);
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [filteredCities, setFilteredCities] = useState([]);
  const inputRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleFilterChange = (e) => {
    const text = e.target.value;
    setFilterText(text);
    setSelectedCity(null); // Clear selected city

    // Filter cities based on input text
    const filtered = cities.filter((cityObj) => cityObj.city.toLowerCase().includes(text.toLowerCase()));

    setFilteredCities(filtered);
  };

  const handleCitySelect = (cityObj) => {
    setFilterText(cityObj.city);
    setSelectedCity(cityObj);
    setFilteredCities([]); // Clear suggestions
    onSelect(cityObj);
  };

  const handleClearSelection = () => {
    setFilterText('');
    setSelectedCity(null);
    onSelect(null); // Clear the selected city
  };

  const handleInputFocus = () => {
    setFilteredCities(cities);
    setIsInputFocused(true);
  };

  const handleInputBlur = () => {
    setIsInputFocused(false);
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target) && event.target.tagName !== 'LI') {
      setFilteredCities([]); // Clear suggestions
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);
  const highlightMatchedLetters = (city) => {
    const lowerFilterText = filterText.toLowerCase();
    const lowerCity = city.toLowerCase();
    const matchIndex = lowerCity.indexOf(lowerFilterText);

    if (matchIndex !== -1) {
      return (
        <span>
          {city.substring(0, matchIndex)}
          <strong>{city.substring(matchIndex, matchIndex + filterText.length)}</strong>
          {city.substring(matchIndex + filterText.length)}
        </span>
      );
    }

    return <span>{city}</span>;
  };


  return (
    <div className='city-selector' ref={dropdownRef}>
      <div className='header'>
        <div className='idf-free-delivery justify-content-center align-items-baseline d-flex'>
          <svg width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M11.665 8.757c0 3.667 3.334 4.584 5 4.584v7.5c0 .416-5.833 1.666-7.5 1.666-1.333 0-2.222-.556-2.5-.833-.277-1.111-1.078-3.896-1.666-6.25-.834-3.334 2.5-2.917 4.166-2.917 0-1.111.084-3.5.417-4.166 1.25-1.25 1.667-.834 2.083.416z'
              fill='#E0C1FF'
            />
            <path
              d='M10.735 22.922H8.017a2.35 2.35 0 0 1-2.305-1.912l-1.007-3.662c-.896-2.558-.506-3.92-.02-4.612a2.019 2.019 0 0 1 1.694-.882h2.226a8.906 8.906 0 0 1 .093-2.776c.542-2.18 1.727-2.275 2.21-2.215.757.094 1.445.757 1.445 1.391a4.217 4.217 0 0 0 1.109 3.125c1.128 1.135 3.164 1.44 3.184 1.442a.565.565 0 0 1-.159 1.12c-.098-.013-2.43-.362-3.82-1.762a5.313 5.313 0 0 1-1.438-3.894.66.66 0 0 0-.531-.301c-.36.014-.7.526-.909 1.369-.286 1.154.007 2.956.01 2.974a.569.569 0 0 1-.126.46.561.561 0 0 1-.43.2H6.38a.9.9 0 0 0-.775.403c-.22.313-.644 1.291.168 3.6a.717.717 0 0 1 .012.038l1.019 3.703a.612.612 0 0 1 .01.05c.107.584.613 1.01 1.204 1.01h2.718c2.07 0 4.83-.465 5.428-1.085a.56.56 0 0 1 .795-.013.569.569 0 0 1 .013.8c-1.124 1.167-4.975 1.43-6.236 1.43z'
              fill='var(--theme-primary, #810ea9)'
            />
            <path
              d='M20.272 22.849h-3.706a.564.564 0 0 1-.562-.566v-9.635c0-.313.252-.566.562-.566h3.706c.31 0 .562.253.562.566v9.635a.564.564 0 0 1-.562.566z'
              fill='var(--theme-primary, #810ea9)'
            />
            <path
              d='M17.129 21.714h2.58V13.21h-2.58v8.503zM10.648 5.654a.564.564 0 0 1-.562-.566v-1.6c0-.313.252-.566.562-.566.31 0 .563.253.563.566v1.6a.564.564 0 0 1-.563.566zM13.547 7.31a.568.568 0 0 1-.29-1.051l1.362-.825a.56.56 0 0 1 .568-.017.566.566 0 0 1 .012.986l-1.362.826a.557.557 0 0 1-.29.08zM7.753 7.308a.557.557 0 0 1-.29-.08l-1.362-.826a.568.568 0 0 1-.184-.772.56.56 0 0 1 .764-.198l1.362.825a.568.568 0 0 1-.29 1.051z'
              fill='var(--theme-primary, #810ea9)'
            />
          </svg>

          <span>תוכלו לאסוף החל מתאריך {new Date(pickupDate).toLocaleDateString("en-GB")}</span>
        </div>
        <span className='title'>מציאת מרכז שירות</span>
        <span className='sub-title'>הקלידו את שם הישוב בו אתם גרים</span>
      </div>
      <div className={`input-container${isInputFocused ? ' focused' : ''}`} ref={inputRef}>
        <input
          type='text'
          className='form-control'
          placeholder='חפש יישוב'
          value={selectedCity ? selectedCity.city : filterText}
          onChange={handleFilterChange}
          onFocus={handleInputFocus}
          onBlur={handleInputBlur}
        />
        {selectedCity && <CloseButton onClick={handleClearSelection} />}
      </div>
      {filteredCities.length > 0 && (
        <div className='suggestions-container'>
          <ul className='suggestions-list'>
            {filteredCities.map((cityObj, index) => (
              <li className={filteredCities.length > 1 ? 'with-border' : ''} key={index} onClick={() => handleCitySelect(cityObj)}>
                {highlightMatchedLetters(cityObj.city)}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default CitySelector;
